export const COMPONENT_NAME = "admin-config-commission-field";
